<template>
  <div class="map-controls-wrapper">
    <map-controls-left :categories="state.categories"></map-controls-left>
    <map-controls-right
      :grayscale="grayscale"
      :toggleScale="toggleScale"
      :state="state"
      :riskData="riskData">
    </map-controls-right>
  </div>
</template>

<script>
import MapControlsRight from './MapControlsRight';
import MapControlsLeft from './MapControlsLeft';

export default {
  name: 'map-controls',
  props: ['grayscale', 'toggleScale', 'state', 'riskData'],
  components: {
    'map-controls-left': MapControlsLeft,
    'map-controls-right': MapControlsRight,
  },
};
</script>

<style lang="less">
  .map-controls-wrapper {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
    height: 110px;
  }
</style>



// WEBPACK FOOTER //
// MapControls.vue?539c9395